import { render, staticRenderFns } from "./WelcomeCoin.vue?vue&type=template&id=47cd29e9&scoped=true&"
import script from "./WelcomeCoin.vue?vue&type=script&lang=ts&"
export * from "./WelcomeCoin.vue?vue&type=script&lang=ts&"
import style0 from "./WelcomeCoin.vue?vue&type=style&index=0&id=47cd29e9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cd29e9",
  null
  
)

export default component.exports